export default "__VITE_ASSET__DCHDadTF__"